import React from "react";
import { Box } from "@mui/material";

// Default container for a worklist page; fills viewport so inner content can expand to full height.
const DefaultWrapper = (props: any) => {
    return (
        <Box sx={{
            height: '100%',
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            padding: 0,
            margin: 0,
        }}>
            {props.children}
        </Box>
    );
}

export default DefaultWrapper;